import React, { useId, useState } from 'react';

export default function PanelHelpBadge({
  title,
  description,
  interpretation,
  metricExample = '',
  side = 'right'
}) {
  const [open, setOpen] = useState(false);
  const tooltipId = useId();
  const exampleText = String(metricExample || '').trim();
  const sideClass = side === 'left' ? 'right-6' : 'left-6';

  return (
    <span className="relative inline-flex items-center">
      <button
        type="button"
        className="inline-flex h-5 w-5 items-center justify-center rounded-full border border-amber-300 bg-amber-50 text-[11px] font-black text-amber-700 hover:bg-amber-100 focus:outline-none focus:ring-2 focus:ring-amber-400 dark:border-amber-700 dark:bg-amber-900/30 dark:text-amber-300"
        aria-label={`${title} açıklaması`}
        aria-describedby={tooltipId}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={() => setOpen((v) => !v)}
      >
        !
      </button>
      {open && (
        <span
          id={tooltipId}
          role="tooltip"
          className={`absolute top-0 z-30 w-72 rounded-lg border border-slate-200 bg-white p-3 text-xs text-slate-700 shadow-xl dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 ${sideClass}`}
        >
          <strong className="block text-[11px] font-black text-slate-900 dark:text-white">{title}</strong>
          <span className="mt-2 block rounded-md border border-slate-200 bg-slate-50 px-2 py-1 text-[11px] text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200">
            <span className="font-bold">Bu panel neyi anlatır?</span> {description}
          </span>
          {interpretation ? (
            <span className="mt-2 block rounded-md border border-slate-200 bg-slate-50 px-2 py-1 text-[11px] text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300">
              <span className="font-bold">Nasıl okunur?</span> {interpretation}
            </span>
          ) : null}
          {exampleText ? (
            <span className="mt-2 block rounded-md border border-slate-200 bg-slate-50 px-2 py-1 text-[11px] text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300">
              <span className="font-bold">Örnek okuma:</span> {exampleText}
            </span>
          ) : null}
        </span>
      )}
    </span>
  );
}
